import { LoginTypes, useSubjectSelector } from '@procom-labs/common'

import { authStore } from '@auth-portal/store'

interface ILoginProfiles {
  isContractorLogin: boolean
  isClientLogin: boolean
  isCustomerLogin: boolean
  isGorillaResumeLogin: boolean
}

export const useLoginTypes = (): ILoginProfiles => {
  const { loginType } = useSubjectSelector(authStore, ['loginType'])

  const isContractorLogin =
    loginType?.toLowerCase() === LoginTypes.Contractor.toLowerCase()
  const isClientLogin =
    loginType?.toLowerCase() === LoginTypes.Client.toLowerCase()
  const isCustomerLogin =
    loginType?.toLowerCase() === LoginTypes.Customer.toLowerCase()
  const isGorillaResumeLogin =
    loginType?.toLowerCase() === LoginTypes.GorillaResume.toLowerCase()

  return {
    isContractorLogin,
    isClientLogin,
    isCustomerLogin,
    isGorillaResumeLogin,
  }
}
